module.exports = __webpack_public_path__ + "img/12.49153a63.jpg";